import { useTheme } from "@emotion/react"

import {
  Dialog,
  DialogTitle,
  List,
  ListItem,
  ListItemText,
  Menu,
  MenuItem,
  Typography,
  useMediaQuery,
} from "@mui/material"

export const UILanguageSelectorBox = ({
  id,
  anchorEl,
  open,
  onClose,
  MenuListProps,
  languageList,
  onSelectLanguage = () => {},
}) => {
  const theme = useTheme()
  const isSmallDevice = useMediaQuery(theme.breakpoints.down("md"))

  const handleItemClick = (language) => {
    const selectedId = language.languageId || language.id
    onSelectLanguage(selectedId)
    onClose()
  }

  if (isSmallDevice) {
    return (
      <Dialog onClose={onClose} open={open} fullWidth>
        <DialogTitle>Set language</DialogTitle>
        <List>
          {languageList.map((language) => (
            <ListItem
              key={language.languageId || language.id}
              onClick={() => handleItemClick(language)}
            >
              <ListItemText>{language.name} </ListItemText>
            </ListItem>
          ))}
        </List>
      </Dialog>
    )
  }

  return (
    <Menu {...{ id, anchorEl, open, onClose, MenuListProps }} elevation={2}>
      {languageList.map((language) => (
        <MenuItem
          key={language.languageId || language.id}
          onClick={() => handleItemClick(language)}
        >
          <Typography variant="span">{language.name} </Typography>
        </MenuItem>
      ))}
    </Menu>
  )
}
